module.exports = __webpack_public_path__ + "a267d6552824f60cf7f85247eab1536e.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/members/sirlova.jpg
// module id = 1244
// module chunks = 0